import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { share, tap } from 'rxjs/operators';

import { IModalComponent, IModalData } from '@app/interfaces';
import { IOUList } from '@app/modules/admin-panel/domain/models/admin';
import { OrganizationsService } from '@app/services/organizations.service';
import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { isObjectEmpty } from '@utils/helpers';
import { PartnerService } from '../../../services/partner.service';

export interface ISelectOrgUnitOptions {
	orgId: number;
	selectedOU: string;
}

@Component({
	selector: 'app-partner-select-org-unit-modal',
	templateUrl: './partner-select-org-unit-modal.component.html',
	styleUrls: ['./partner-select-org-unit-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerSelectOrgUnitModalComponent implements IModalComponent<ISelectOrgUnitOptions>, OnInit {
	@Input() data: IModalData<ISelectOrgUnitOptions>;
	isLoading$ = new BehaviorSubject(false);
	orgUnits$: Observable<IOUList>;
	orgId: number;
	selectedOrgUnitKey: string;

	isEmpty = isObjectEmpty;

	orgUnitControl = new FormControl('', Validators.required);

	constructor(
		private partnerService: PartnerService,
		private orgService: OrganizationsService,
		private toastService: WrapToasterService,
	) {}

	ngOnInit() {
		this.orgId = this.data.options['orgId'];
		const selectedOU = this.data.options['selectedOU']; // could be either key or name

		this.orgUnits$ = this.orgService.getOU(this.orgId).pipe(
			share(),
			tap((resp) => {
				const units = resp.OU;
				// search selected by key first if failed -> search by name
				this.selectedOrgUnitKey = !!units[selectedOU] ? selectedOU : this.findOUByName(selectedOU, units);
				this.orgUnitControl.patchValue(this.selectedOrgUnitKey);
			}),
		);
	}

	findOUByName(name: string, orgUnits: { [key: string]: string }): string {
		return Object.keys(orgUnits)
			.filter((key) => orgUnits[key] === name)
			.shift();
	}

	selectOrgUnit() {
		this.selectedOrgUnitKey = this.orgUnitControl.value;
		const selectedOU = this.orgUnitControl.value;
		this.isLoading$.next(true);
		this.partnerService.selectOU(this.orgId.toString(), selectedOU).subscribe({
			next: (resp) => {
				this.isLoading$.next(false);
				this.toastService.showToast('success', 'Success!', 'OU was changed');
				this.closeEvent({ message: 'ouChanged' });
			},
			error: (err) => {
				this.isLoading$.next(false);
				this.toastService.handleRequestFailed(err);
				this.closeEvent();
			},
		});
	}

	closeEvent(e?: {}): void {}
}
